<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    :placeholder="placeholder"
    :clearable="clearable"
    idKey="AccountId"
    labelKey="AccountName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择账号",
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/account").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

